import React, { useEffect, useState } from "react";

interface props {
  IeRg: any;
  value: any;
  idCnpj?: any;
  handleChange: any;
  handleBlur: any;
  className: any;
  setCustomerData: any;
  setIsInvalid: any;
}

const InputIeRg: React.FC<props> = ({ IeRg, idCnpj, handleChange, handleBlur, setCustomerData, value, className, setIsInvalid }) => {
  const [label, setLabel] = useState(<label><label>Informe RG</label> <small>(Registro Geral)</small></label>)
  const [invalidFeedBack, setInvalidFeedBack] = useState("")
  const [disable, setDisable] = useState(false)

  const inputSwitch = () => {
    switch (IeRg) {
      case "FÍSICA":
        setLabel(<label>Informe RG<small>(Registro Geral)</small></label>)
        setInvalidFeedBack('Insira um RG Válido')
        setDisable(false)
        break;
      case "JURÍDICA":
        setLabel(<label>Informe IE <small>(Inscrição Estadual)</small></label>)
        setInvalidFeedBack('Insira um IG Válido')
        break;
      case "stranger":
        setLabel(<label>Informe Documento do <b>Cliente</b></label>)
        setInvalidFeedBack('Insira um Documento Válido')
        break;
    }
  }

  const handleClick = () => {

    if (value != "ISENTO") {
      setCustomerData((prevForm: any) => ({
        ...prevForm,
        ierg: "ISENTO",
      }));
      setIsInvalid((prevForm: any) => ({
        ...prevForm,
        ierg: false,
      }));
      setDisable(true)
    } 

    else {
      setCustomerData((prevForm: any) => ({
        ...prevForm,
        ierg: "",
      }));
      setIsInvalid((prevForm: any) => ({
        ...prevForm,
        ierg: false,
      }));
      setDisable(false)
    }
    
  }

  useEffect(() => {
    inputSwitch()
    if(value == "ISENTO"){
      setDisable(true)
    }
  }, [IeRg])

  return (
    <div className="col-md-6 col-lg-4">
      {label}
      <div className="input-group">
        <input
          id='ierg'
          className={className}
          type="text"
          placeholder="Somente Números"
          value={value}
          onChange={handleChange}
          disabled={disable ||idCnpj ? true : false}
          onBlur={handleBlur}
          style={{ borderRadius: "5px 0px 0px 5px" }}
        />
        <button className={`btn btn-outline-primary `} style={{ borderRadius: "0px 5px 5px 0px" }}
          disabled={idCnpj ? true : false} onClick={handleClick}>Isento?</button>
        <p className="invalid-feedback">{invalidFeedBack}</p>
      </div>
    </div>
  )
}

export default InputIeRg